import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import queryString from "query-string";
import {withRouter} from "react-router";
import ViewPersonRender from "./ViewPersonRender";
import {WorkplaceTypes} from "../Common/constants";

class ViewPerson extends Component {
    constructor(props, context) {
        super(props, context);

        this.tabNumAccess = {};

        if (!this.isMyProfile()) {
            this.tabNumAccess.getTabNum = this.getTabNumFromQuery;
            this.tabNumAccess.getItemParams =() => {return {"SubTabNum": this.getTabNumFromQuery()}};
        }
        else
        {
            this.tabNumAccess.getTabNum = () => { return this.props.homeState.appParams.tabNum};
            this.tabNumAccess.getItemParams = () => {return {}};
        }
    }

    isMyProfile() {
        return !this.getTabNumFromQuery();
    }

    getTabNumFromQuery = () => {
        const pageParams = queryString.parse(this.props.location.search);
        return pageParams.TabNum;
    };

    componentDidMount() {
        this.initItem().catch(e=>console.error(e));
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            this.initItem().catch(e=>console.error(e));
        }
    }

    async initItem() {
        await this.props.dispatch(this.props.titleInfoItem.reset());
        await this.props.dispatch(this.props.generalInfoItem.reset());
        await this.props.dispatch(this.props.detailsInfoItem.reset());
        await this.props.dispatch(this.props.treeInfoItem.reset());

        const params = this.tabNumAccess.getItemParams();

        await this.props.dispatch(this.props.titleInfoItem.execute(params, {withParams: false, newItem: true}));
        await this.props.dispatch(this.props.generalInfoItem.execute(params, {withParams: false, newItem: true}));
        await this.props.dispatch(this.props.detailsInfoItem.execute(params, {withParams: false, newItem: true}));
        await this.props.dispatch(this.props.treeInfoItem.execute(params, {withParams: false, newItem: true}));
    }

    render() {

        return (
            <ViewPersonRender titleInfo={this.props.titleInfoItem}
                              generalInfo={this.props.generalInfoItem}
                              detailsInfo={this.props.detailsInfoItem}
                              treeInfo={this.props.treeInfoItem}
                              tabNum={this.tabNumAccess.getTabNum()}
                              dispatch={this.props.dispatch}
            />
        );
    }
}

ViewPerson.propTypes = {
    dispatch: PropTypes.func.isRequired,
    titleInfoItem: PropTypes.object,
    generalInfoItem: PropTypes.object,
    detailsInfoItem: PropTypes.object,
    treeInfoItem: PropTypes.object
};


ViewPerson.defaultProps = {};

function mapStateToProps(state) {
    function getDataItem() {
        switch (state.appState.appParams.workplaceType) {
            case WorkplaceTypes.Slavutich: {
                return state.aboutMeState.ListGenForPO_Slavutich;
            }
            default: {
                return state.aboutMeState.ListGenForPO;
            }
        }
    }

    return {
        homeState: state.appState,
        titleInfoItem: state.aboutMeState.ListForPODesc1,
        generalInfoItem: getDataItem(),
        detailsInfoItem: state.aboutMeState.ListForPODesc2,
        treeInfoItem: state.aboutMeState.TreeForNewPO
    };
}

export default withRouter(connect(mapStateToProps)(ViewPerson));